export const CHANNEL = 'channel';
export const DM = 'dm';
export const INVITE_TEAM_VIEW_THRESHOLD = 3; // disable unlocking feature for now
